import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 rounded-3xl overflow-hidden shadow-2xl">
          <div className="relative bg-[#faf8f5] min-h-[500px]">
            <img
              src="https://public.readdy.ai/ai/img_res/3606a7d69d79ff629ecc5256f0aca126.jpg"
              alt="学習塾NICKで勉強する生徒たち"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent"></div>
            <div className="absolute bottom-10 left-10">
              <h3 className="text-4xl font-bold text-white leading-tight">
                まずは<br />無料体験から
              </h3>
            </div>
          </div>

          <div className="bg-white p-12 flex flex-col justify-center">
            <h3 className="text-4xl md:text-5xl font-bold text-[#1a2332] mb-6 leading-tight">
              お気軽に<br />ご相談ください
            </h3>

            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              <strong>廿日市市大野</strong>の学習塾NICKでは、<strong>中学生</strong>の<strong>成績アップ</strong>と<strong>志望校合格</strong>を全力でサポートします。<strong>定期テスト対策</strong>、<strong>高校受験対策</strong>、<strong>内申点アップ</strong>など、お子様の学習に関するお悩みをお聞かせください。経験豊富な講師が、一人ひとりに最適な学習プランをご提案いたします。
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-[#4a90e2]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xl text-[#4a90e2]"></i>
                </div>
                <p className="text-gray-700">無料体験授業で実際の雰囲気を体感</p>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-[#4a90e2]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xl text-[#4a90e2]"></i>
                </div>
                <p className="text-gray-700">個別面談で学習状況をヒアリング</p>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-[#4a90e2]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xl text-[#4a90e2]"></i>
                </div>
                <p className="text-gray-700">個別相談で最適な学習プランをご提案</p>
              </div>
            </div>

            <Link
              to="/trial#trial-form-section"
              className="bg-[#6b4423] text-white px-12 py-6 rounded-full text-xl font-bold hover:bg-[#5a3a1e] transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
            >
              無料体験に申し込む
              <i className="ri-arrow-right-line text-2xl"></i>
            </Link>

            <p className="text-sm text-gray-500 mt-6 text-center">
              廿日市市、宮島、阿品、大竹市など周辺地域からも通塾可能
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
